const LOGGED_IN_USER = "LOGGED_IN_USER";
const ACTIVE_USER_TYPE = 'ACTIVE_USER_TYPE';

export {
    LOGGED_IN_USER,
    ACTIVE_USER_TYPE
}